const categoryColors = {
    1: { background: "#f0c753", textColor: "#000", buttonColor: "#f0c753", borderColor: "#f0c753", },
  };
  
  export default categoryColors;
  